import React, { useState, useEffect, useRef } from "react";
import { Table, Form, Button } from "react-bootstrap";
import ExportExcel from "../../utility/ExportCSV";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/authFetch";

function DoctorWiseReportTable({
  fromDate,
  toDate,
  doctor,
  setLoader,
  setButtonClicked,
}) {
  const [entries, setEntries] = useState([]);
  const tableRef = useRef();

  useEffect(() => {
    if (fromDate === "" || toDate === "" || doctor === "" || doctor === null)
      return;
    if (!setButtonClicked) return;
    authFetch(
      `${API_BASE_URL}/api/doctor-wise-report?fromDate=${fromDate}&toDate=${toDate}&doctor=${doctor}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          alert("Error fetching data");
          setButtonClicked(false);
          setLoader(false);
          return;
        }
        setEntries(data.report);
        setButtonClicked(false);
        setLoader(false);
      })
      .catch((err) => {
        console.error("Error fetching entries:", err);
        setButtonClicked(false);
        setLoader(false);
        return;
      });
  }, [fromDate, toDate, doctor]);

  const totalRegistration = entries.reduce(
    (sum, item) => sum + (Number(item.registrationFee) || 0),
    0
  );

  const totalTestFee = entries.reduce(
    (sum, item) => sum + (Number(item.testFee) || 0),
    0
  );

  const totalCash = entries.reduce(
    (sum, item) =>
      sum +
      ((item.registrationFeeMode === "Cash"
        ? Number(item.registrationFee)
        : 0) || 0) +
      ((item.testFeeMode === "Cash" ? Number(item.testFee) : 0) || 0),
    0
  );

  const totalOnline = entries.reduce(
    (sum, item) =>
      sum +
      ((item.registrationFeeMode !== "Cash"
        ? Number(item.registrationFee)
        : 0) || 0) +
      ((item.testFeeMode !== "Cash" ? Number(item.testFee) : 0) || 0),
    0
  );

  const totalRefund = entries.reduce(
    (sum, item) =>
      sum +
      ((item.status === "Refund"
        ? Number(item.registrationFee) + Number(item.testFee)
        : 0) || 0),
    0
  );

  const grandTotal = totalRegistration + totalTestFee;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <ExportExcel
          tableId="doctor-wise-report-table"
          filename={`${doctor}-report-${fromDate}-to-${toDate}.csv`}
        />
      </div>
      <Table
        striped
        bordered
        hover
        id="doctor-wise-report-table"
        ref={tableRef}
      >
        <thead>
          <tr>
            <th>SL NO.</th>
            <th>PATIENT NAME</th>
            <th>VISIT DATE</th>
            <th>REGISTRATION FEE</th>
            <th>TEST DATE</th>
            <th>TEST FEE</th>
            <th>TOTAL</th>
            <th>REMARKS</th>
          </tr>
        </thead>
        <tbody>
          {entries.length > 0 ? (
            <>
              {entries.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.patientName}</td>
                  <td>
                    {item.visitDate !== null &&
                      item.visitDate
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")}
                  </td>
                  <td>{item.registrationFee}</td>
                  <td>
                    {item.testDate !== null &&
                      item.testDate
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")}
                  </td>
                  <td>{item.testFee || 0}</td>
                  <td>
                    {(Number(item.registrationFee) || 0) +
                      (Number(item.testFee) || 0)}
                  </td>
                  <td className="fw-bold">
                    {item.status === "Refund" && "REFUND"}
                  </td>
                </tr>
              ))}

              {/* ✅ Total Row */}
              <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
                <td colSpan="3" className="text-end">
                  TOTAL:
                </td>
                <td>{totalRegistration}</td>
                <td></td>
                <td>{totalTestFee}</td>
                <td>{grandTotal}</td>
                <td></td>
              </tr>

              <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
                <td colSpan="4" className="text-end">
                  CASH:
                </td>
                <td colSpan="3">{totalCash}</td>
                <td></td>
              </tr>

              <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
                <td colSpan="4" className="text-end">
                  ONLINE:
                </td>
                <td colSpan="3">{totalOnline}</td>
                <td></td>
              </tr>

              <tr
                style={{
                  fontWeight: "bold",
                  background: "#f0f0f0",
                }}
              >
                <td colSpan="4" className="text-end" style={{ color: "red" }}>
                  REFUND:
                </td>
                <td colSpan="3" style={{ textAlign: "right", color: "red" }}>
                  {totalRefund}
                </td>
                <td></td>
              </tr>

              <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
                <td colSpan="4" className="text-end">
                  NET TOTAL:
                </td>
                <td colSpan="3" style={{ textAlign: "right" }}>
                  {grandTotal - totalRefund}
                </td>
                <td></td>
              </tr>
            </>
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                No Entries
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export default DoctorWiseReportTable;
